import { render, staticRenderFns } from "./ApplicationLive.vue?vue&type=template&id=1370180b&scoped=true&"
import script from "./ApplicationLive.vue?vue&type=script&lang=js&"
export * from "./ApplicationLive.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationLive.vue?vue&type=style&index=0&id=1370180b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370180b",
  null
  
)

export default component.exports